import z from 'zod';
import identify from './identify.schema';
import page from './page.schema';
import referrer from './referrer.schema';

import customEventSchemas from '../../custom-events';

import environmentOptions from './environment-options.schema';

const schemas = {
  ...customEventSchemas.schemas,
  identify,
  page,
  referrer,
};

export default schemas;
export type EventSchemas = typeof schemas;

export type CustomEvent = keyof typeof customEventSchemas.schemas;
export type TrackEvent = keyof EventSchemas;

export type EnvironmentOptions = z.infer<typeof environmentOptions>;
